import { render, staticRenderFns } from "./PRDs.vue?vue&type=template&id=513d8a3e&scoped=true&"
import script from "./PRDs.vue?vue&type=script&lang=js&"
export * from "./PRDs.vue?vue&type=script&lang=js&"
import style0 from "./PRDs.vue?vue&type=style&index=0&id=513d8a3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d8a3e",
  null
  
)

export default component.exports